import styled from 'styled-components';

import { mediaTopBarHidden, mediaWideNavless } from '@xing-com/layout-tokens';
import {
  SkeletonHeadline,
  SkeletonBodyCopy,
  SkeletonProfileImage,
} from '@xing-com/skeleton';
import {
  scale320,
  scale350,
  spaceXS,
  spaceS,
  spaceM,
  spaceL,
  spaceXL,
  space3XL,
} from '@xing-com/tokens';

const BirthdaysTodayDateHeaderSkeleton = styled.div`
  margin: ${spaceS} 0 ${spaceL};
  padding: ${spaceL} ${spaceXS};

  @media ${mediaTopBarHidden} {
    margin: ${spaceXL} 0 ${spaceL};
  }
`;

const BirthdaysDateHeaderCopySkeleton = styled(SkeletonHeadline)`
  max-width: ${scale320};
`;

const BirthdaysTodayCardContainerSkeleton = styled.div`
  margin-bottom: ${space3XL};

  @media ${mediaWideNavless} {
    padding: 0 ${spaceXS};
  }
`;

const BirthdaysTodayCardProfileImageSkeleton = styled(SkeletonProfileImage)`
  margin-bottom: ${spaceL};
`;

const BirthdaysTodayCardBodyCopySkeleton = styled(SkeletonBodyCopy)`
  margin-bottom: ${spaceL};
`;

const BirthdaysUpcomingDateHeaderSkeleton = styled.div`
  margin-bottom: ${spaceM};
  padding: ${spaceL} ${spaceXS};
`;

const BirthdaysUpcomingCardContainerSkeleton = styled.div`
  display: flex;
  gap: ${spaceM};
  margin-bottom: ${spaceM};
  padding: ${spaceL} 0;

  @media ${mediaWideNavless} {
    gap: ${spaceL};
  }
`;

const BirthdaysUpcomingCardCopySkeleton = styled(SkeletonBodyCopy)`
  display: block;
  padding: ${spaceXS} 0;
  width: ${scale350};
`;

export const Styled = {
  BirthdaysTodayDateHeaderSkeleton,
  BirthdaysDateHeaderCopySkeleton,
  BirthdaysTodayCardContainerSkeleton,
  BirthdaysTodayCardProfileImageSkeleton,
  BirthdaysTodayCardBodyCopySkeleton,
  BirthdaysUpcomingDateHeaderSkeleton,
  BirthdaysUpcomingCardContainerSkeleton,
  BirthdaysUpcomingCardCopySkeleton,
};
